export const randomBetween = function (min: number, max: number, options?: {
  float?: boolean
  biasMax?: number
  biasMin?: number
}) {
  let rnd = Math.random()

  if (options?.biasMax) {
    rnd = 1 - Math.pow(1 - rnd, 1 + options.biasMax * 5)
  } else if (options?.biasMin) {
    rnd = Math.pow(rnd, 1 + options.biasMin * 5)
  }

  const range = max - min + (options?.float ? 0 : 1)
  const result = min + rnd * range

  return options?.float ? result : Math.floor(result)
}

export const shuffleArray = function <T>(array: T[]) {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1))
    const temp = array[i]
    array[i] = array[j]
    array[j] = temp
  }
  
  return array
  return array.sort((a, b) => 0.5 - Math.random()) as T[]
}

export const getBool = function () {
  return Math.random() > 0.5
}

export const getRandomString = function () {
  return Math.random().toString(36).substring(7)
}